import {ShareStatus} from './ShareStore.constants';
import {ShareState, ShareStoreType} from './ShareStore.types';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';

const initialShareState: ShareStoreType = {
  friendRef: {status: ShareStatus.Idle},
};

export class ShareStore extends Store<ShareStoreType> {
  constructor() {
    super(initialShareState);
  }

  public getFriendRefShareState = (): ShareStoreType['friendRef'] => {
    return this.getState().friendRef;
  };

  public setFriendRefShareStatus = (shareState: ShareState): void => {
    const newState = {
      ...this.getState(),
      friendRef: shareState,
    };
    this.setState(newState);
  };

  public setFriendRefShareIdle = (): void => {
    const newState = {
      ...this.getState(),
      friendRef: {status: ShareStatus.Idle},
    };
    this.setState(newState);
  };

  public isFriendRefShareStatusError = (): boolean => {
    return this.getState().friendRef.status === ShareStatus.UnknownError;
  };

  public getFriendRefShareErrorData = (): unknown | undefined => {
    return this.getState().friendRef.error;
  };

  public isShareStatusSuccess = (shareState: ShareState): boolean => {
    return shareState.status === ShareStatus.Success;
  };

  public isShareStatusAborted = (shareState: ShareState): boolean => {
    return shareState.status === ShareStatus.Aborted;
  };

  public isShareStatusUnknownError = (shareState: ShareState): boolean => {
    return shareState.status === ShareStatus.UnknownError;
  };
}

injected(ShareStore);
